<template>
  <div class="junk-catering">
    <!-- 头部 -->
    <v-header></v-header>
    <!-- 广告 -->
    <div class="banner">
      <div class="bg"></div>
      <div class="center">
        <h1>{{ $t("message.junk.banner.h") }}</h1>
        <h3>{{ $t("message.junk.banner.p") }}</h3>
        <menubtn></menubtn>
      </div>
    </div>
    <!-- 内容 -->
    <div class="party-c">
      <div class="main-section1">
        <div class="block">
          <!-- 轮播菜单-->
          <el-carousel trigger="click" :height="imgHeight + 'px'" arrow="always" ref="carouselIitem">
            <el-carousel-item v-for="item in ImageData" :key="item">
              <img :src="item" alt="" ref="image" @click="showImage" />
            </el-carousel-item>
          </el-carousel>
          <div>
            <h2>{{ $t("message.junk.main_section1.h2") }}</h2>
            <h3>{{ $t("message.junk.main_section1.h3") }}</h3>
            <button class="Btn" @click="open">
              {{ $t("message.junk.main_section1.btn") }}
            </button>
          </div>
        </div>
      </div>

      <div class="main-section1">
        <div class="block">
          <!-- 轮播菜单-->
          <el-carousel
            trigger="click"
            :height="imgHeight1 + 'px'"
            arrow="always"
            ref="carouselIitem1"
          >
            <el-carousel-item v-for="item in ImageData1" :key="item">
              <img :src="item" alt="" ref="image1" @click="showImage1" />
            </el-carousel-item>
          </el-carousel>
          <div>
            <h2>{{ $t("message.junk.main_section2.h2") }}</h2>
            <div class="content">
              <h3>{{ $t("message.junk.main_section2.meun1") }}</h3>
              <p>
                {{ $t("message.junk.main_section2.p1") }}
              </p>
              <h3>{{ $t("message.junk.main_section2.meun2") }}</h3>
              <p>
                {{ $t("message.junk.main_section2.p2") }}
              </p>
              <h3>{{ $t("message.junk.main_section2.meun3") }}</h3>
              <p>
                {{ $t("message.junk.main_section2.p3") }}
              </p>
            </div>
            <button class="Btn" @click="open">
              {{ $t("message.junk.main_section2.btn") }}
            </button>
          </div>
        </div>
      </div>

      <div class="activity-contanier">
        <div class="activity-main">
          <Title :title="$t('message.junk.context.h2TitleOne')"></Title>
          <Content :content="$t('message.junk.context.pContentOneFirst')"></Content>
          <Content :content="$t('message.junk.context.pContentOneSecond')"></Content>
          <Content :content="$t('message.junk.context.pContentOneThird')"></Content>
        </div>
      </div>
      <div class="faq-contanier">
        <div class="faq-main">
          <Title :title="$t('message.junk.aboutJunkTitle')"></Title>
          <div class="feq-content">
            <div class="about-food-main">
              <div v-for="item in 3" :key="item" style="margin-left:10px">
                <h3 style="color: #000">{{ $t(`message.junk.aboutJunk.faq${item}`) }}</h3>
                <div style="margin-left:10px" class="feq-content-text">
                  {{ $t(`message.junk.aboutJunk.content${item}`) }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 尾部 -->
    <el-dialog class="Bigimg" :visible.sync="show" width="80%">
      <img :src="src" alt width="100%" height="100%" />
    </el-dialog>
    <el-dialog class="Bigimg" :visible.sync="show1" width="80%">
      <img :src="src1" alt width="100%" height="100%" />
    </el-dialog>
  </div>
</template>

<script>
import header from "../components/header";
import menubtn from "../components/menubtn";
import Title from './common/title.vue'
import Content from './common/content.vue'
export default {
  name: "caterers",
  data() {
    return {
      ImageData: [
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/junk-catering-10.png",
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/junk-catering-20.png",
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/junk-catering-30.png",
      ],
      ImageData1: [
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E5%BE%B7%E5%9C%8B%E8%84%86%E7%82%B8%E9%B9%B9%E8%B1%AC%E6%89%8B.jpg",
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E7%B6%93%E5%85%B8%E5%87%B1%E6%92%92%E7%94%B0%E5%9C%92%E6%B2%99%E5%BE%8B.jpg",
        "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E9%A6%99%E8%92%9C%E8%9C%82%E8%9C%9CBBQ%E7%82%B8%E9%9B%9E%E7%BF%BC.jpg",
      ],
      imgHeight: "",
      imgHeight1: "",
      show: false,
      show1: false,
      src: "",
      src1: "",
    };
  },
  mounted() {
    this.$refs.image[0].onload = () => {
      if (this.$refs.image) {
        this.imgHeight = this.$refs.image[0].height;
        this.imgHeight1 = this.$refs.image1[0].height;
      }
    };
    this.imgLoad();
    // 监听窗口变化，使得轮播图高度自适应图片高度
    window.addEventListener("resize", () => {
      if (this.$refs.image[0]) {
        this.imgHeight = this.$refs.image[0].height;
        this.imgHeight1 = this.$refs.image1[0].height;
      }
    });
  },
  methods: {
    showImage() {
      this.show = true;
      let index = this.$refs.carouselIitem.activeIndex;
      switch (index) {
        case 0:
          this.src =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_10ppl.jpg";
          break;
        case 1:
          this.src =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_20ppl.jpg";
          break;
        case 2:
          this.src =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E8%88%B9p+menu_30ppl.jpg";
          break;
      }
    },
    showImage1() {
      this.show1 = true;
      let index = this.$refs.carouselIitem1.activeIndex;
      switch (index) {
        case 0:
          this.src1 =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E5%BE%B7%E5%9C%8B%E8%84%86%E7%82%B8%E9%B9%B9%E8%B1%AC%E6%89%8B.jpg";
          break;
        case 1:
          this.src1 =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E7%B6%93%E5%85%B8%E5%87%B1%E6%92%92%E7%94%B0%E5%9C%92%E6%B2%99%E5%BE%8B.jpg";
          break;
        case 2:
          this.src1 =
            "https://catering-webapp.s3.ap-east-1.amazonaws.com/static/img/%E9%A6%99%E8%92%9C%E8%9C%82%E8%9C%9CBBQ%E7%82%B8%E9%9B%9E%E7%BF%BC.jpg";
          break;
      }
    },
    imgLoad() {
      this.$nextTick(function () {
        if (this.$refs.image) {
          // 获取窗口宽度*图片的比例，定义页面初始的轮播图高度
          this.imgHeight = this.$refs.image[0].height;
          this.imgHeight1 = this.$refs.image1[0].height;
        }
      });
    },
    open() {
      if (this.$i18n.locale === "zh") {
        window.open("https://cateraway.rakosell.com/zh/products", "_blank");
      } else {
        window.open("https://cateraway.rakosell.com/en/products", "_blank");
      }
    },
  },
  components: {
    "v-header": header,
    menubtn,
    Title,
    Content
  },
};
</script>
<style lang="less" scoped>
.activity-contanier {
  background-size: 100% 100%;

  .activity-main {
    width: 70%;
    padding: 3% 2%;
    margin: 0 auto;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .activity-content-main {
      display: flex;
      justify-content: space-around;
      @media (max-width: 768px) {
        flex-wrap: wrap;
        justify-content: space-between;
      }

      .activity-item ~ .activity-item {
        margin-left: 30px;
        @media (max-width: 768px) {
          margin-left: 0px;
        }
      }

      .activity-item {
        text-align: center;
        flex: 0 0 30%;
        @media (max-width: 768px) {
          flex: 0 0 48%;
        }
        @media (max-width: 480px) {
          flex: 0 0 100%;
          display: flex;
          margin-bottom: 3%;
          text-align: left;
        }

        .activity-item-img {
          .item-img {
            width: 100%;
            height: 100%;
          }

          @media (max-width: 480px) {
            flex: 0 0 48%;
          }
        }

        .activity-item-content, .activity-item-span {
          margin: 20px;
        }

        .activity-item-content {
          font-size: 1.2vw;
          font-weight: 550;
        }

        .activity-item-span {
          font-size: 13px;
          color: #919599;
          font-weight: 350;
        }

        .item-button {
          @media (max-width: 480px) {
            margin: 0 20px;
          }
        }
      }
    }
  }
}
.faq-contanier {
  .faq-main {
    width: 70%;
    margin: 0 auto;
    padding:30px 0;
    @media (max-width: 1255px) {
      width: 90%;
    }

    .feq-content {
      margin: 0 0 3%;
      font-size: .825rem;
      color: #919599;

      .feq-content-text {
        margin-bottom: 3%;
      }
    }

  }
}
.content h3 {
  text-align: left;
  margin-bottom: 2% !important;
}
.block {
  width: 80%;
  display: flex;
  justify-content: center;
  margin: 3% auto;
  align-items: center;
}
.block div:last-child {
  flex: 0 0 40%;
}
.block div:last-child h2,
.block div:last-child h3 {
  margin: 5% 0;
}
.block img {
  width: 75%;
}
.Btn {
  padding: 0.6em;
  border-radius: 4px;
  border: 0px;
  background-color: #eb6410;
  color: white;
  margin-top: 1rem;
  width: 10rem;
  cursor: pointer;
}
.party-c .main-section1 {
  padding: 2% 0;
  text-align: center;
}
.content p {
  text-align: left;
  margin: 2% 0;
  font-size: 1em;
}
.party-c .main-section1 > h2 {
  color: #eb6410;
}
.center {
  width: 75%;
  margin: auto;
}
/* 广告 */
.banner {
  position: relative;
  width: 100%;
  height: 650px;
  background: url("../assets/images/JunkBoatHeroBanner.jpg") no-repeat;
  background-size: 100% 100%;
  margin: 100px 0 0 0;
}
.banner h1,
.banner h3 {
  text-align: center;
  color: white;
  margin: 0 5px 5px 5px;
  font-weight: 500;
}
.banner h1 {
  font-size: 50px;
}
.banner h3 {
  margin: 1% 0;
  font-size: 2vw;
}
.banner .center {
  width: 80%;
  height: 40%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  margin: auto;
}
.banner .banner-call1 {
  font-weight: 200;
  color: #eb6410;
  letter-spacing: 0;
  margin: 0 0 3% 0;
  font-size: 1.1rem;
}
.seo {
  margin: 2% 0;
  overflow: hidden;
}
.seo-show {
  overflow: hidden;
  position: relative;
}
.seo h1 {
  text-align: center;
  color: #eb6410;
  font-weight: 300;
  margin-top: 2%;
}
.seo-show > div {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  float: left;
  width: 200px;
  padding: 0 3%;
  box-sizing: border-box;
}
.seo img {
  width: 250px;
}
.seo p {
  float: right;
  margin: 2% auto;
  font-size: 14px;
  width: 70%;
  text-indent: 2rem;
}
@media (max-width: 1000px) {
  .junk-catering .el-carousel.el-carousel--horizontal {
    flex: 0 0 80%;
    width: 70% !important;
  }
  .block {
    flex-wrap: wrap;
  }
  .block div:last-child {
    flex: 0 0 100%;
  }
  .Bigimg .el-dialog {
    width: 90% !important;
  }
}
@media (max-width: 820px) {
  .banner {
    height: 500px;
  }
  .banner h1 {
    font-size: 25px;
  }
  /* seo */
  .seo h1 {
    font-size: 1.4rem;
    margin: 3% 0;
  }
  .seo p {
    width: 100%;
    font-weight: 400;
    padding: 0 3%;
    box-sizing: border-box;
  }
  .center {
    width: 100%;
  }
  .seo-show > div {
    width: 100%;
    position: static;
    top: 0;
    transform: translateY(0);
    float: none;
  }
  .seo img {
    width: 100%;
  }
}
@media (max-width: 480px) {
  .Bigimg .el-dialog {
    width: 98% !important;
  }
  .banner {
    height: 250px;
  }
  .junk-catering .el-carousel.el-carousel--horizontal {
    width: 90% !important;
    flex: 0 0 100%;
  }
  .block img {
    width: 80%;
  }
  .banner h3 {
    font-size: 4vw;
  }
}
</style>
<style>
.junk-catering .el-carousel__arrow {
  background-color: #ff5809;
}
.junk-catering .el-carousel.el-carousel--horizontal {
  width: 50% !important;
  flex: 0 0 50%;
}
.junk-catering .banner .el-button.el-button--success {
  display: block;
  width: 100%;
  background: #eb6410;
  border: 1px solid #eb6410;
}
.junk-catering .banner .el-dialog {
  margin-top: 12vh !important;
}
.junk-catering .banner .el-dialog__body {
  padding: 0 33px 0 0 !important;
}
.junk-catering .el-scrollbar__view.el-time-spinner__list li,
.el-scrollbar__view.el-select-dropdown__list li {
  display: block;
}
@media (max-width: 1000px) {
  .junk-catering .Bigimg .el-dialog {
    width: 90% !important;
  }
}
@media (max-width: 480px) {
  .junk-catering .Bigimg .el-dialog {
    width: 98% !important;
  }
}
</style>
